(function () {
  function initCkVideo(root) {
    (root || document).querySelectorAll('[data-ck-video]').forEach((wrap) => {
    if (wrap.dataset.ckVideoReady === 'true') return;
    wrap.dataset.ckVideoReady = 'true';
    const openBtn = wrap.querySelector('[data-ck-open]');
    const modal = wrap.querySelector('[data-ck-modal]');
    const closeBtn = modal?.querySelector('[data-ck-close]');

    if (!openBtn || !modal) return;

    let moved = false;

    function open() {
      if (!moved) {
        document.body.appendChild(modal);
        moved = true;
      }

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.classList.remove('is-vertical'); // default: no class for horizontal
      requestAnimationFrame(() => modal.classList.add('is-open'));

      // Load iframe (from data-src) - this triggers autoplay
      modal.querySelectorAll('iframe[data-src]').forEach((f) => {
        f.src = f.dataset.src;
      });

      // Play video with sound + detect orientation
      const video = modal.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.muted = false;
        const onMeta = () => {
          if (video.videoHeight > video.videoWidth) modal.classList.add('is-vertical');
          video.removeEventListener('loadedmetadata', onMeta);
        };
        video.addEventListener('loadedmetadata', onMeta);
        if (video.readyState >= 1) onMeta();
        video.play().catch(() => {
          video.muted = true;
          video.play();
        });
      } else if (wrap.hasAttribute('data-ck-vertical')) {
        modal.classList.add('is-vertical');
      }

      document.addEventListener('keydown', onKey);
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';

      // Pause and reset video
      const video = modal.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      // Clear iframe src (stops playback)
      modal.querySelectorAll('iframe').forEach((f) => {
        f.src = '';
      });

      setTimeout(() => { modal.hidden = true; }, 200);
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    openBtn.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) close();
    });
    });
  }

  initCkVideo(document);
  document.addEventListener('shopify:section:load', (event) => initCkVideo(event.target));
})();
